import { AusState } from "@aus/Store/AusState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: AusState) => ({
    filtersOpen: state.workOrderHistoryPageReducer.filtersOpen,
});

export interface OrderHistorySearchFormStyles {
    wrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
}

export const searchFormStyles: OrderHistorySearchFormStyles = {
    wrapper: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    headingText: { variant: "h5" },
};

const styles = searchFormStyles;

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const OrderHistorySearchForm: React.FunctionComponent<Props> = props => {
    if (!props.filtersOpen) {
        return <Zone contentId={props.id} zoneName="Content01" />;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.headingText}>
                {translate("Filter")}
            </Typography>
            <Zone contentId={props.id} zoneName="Content" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderHistorySearchForm),
    definition: {
        group: "Order History",
        displayName: "Work Order Search Form",
        allowedContexts: ["WorkOrderHistoryPage"] as any,
    },
};

export default widgetModule;
